import {request} from './request'
const newsApi={
  //列表
  getList:params=>{
    let params2={
      page:params.page,
      pageSize:params.pageSize?params.pageSize:8,
      is_top: -1,    //是否置顶
      brand_id:params.brand_id?params.brand_id : -1,
      activity_id: params.activity_id ? params.activity_id:-1,
      recommend: params.recommend ? params.recommend :-1,  //是否推荐
    }
    return request({url: '/NewsApi/GetList',params:params2});
  },
  

  //单一节目内容
  getOneById:params=>{
    // id
    return request({url: '/NewsApi/GetById',params:params,});
  },
  //其它相关新闻
  getOtherList:params=>{
    let params2={
      id:params.id,
      pageSize:params.pageSize || 5
    }
    return request({url: '/NewsApi/GetOtherList',params:params2});
  },

  //预览单一节目内容
  previewId: params => {
    // id
    return request({ url: '/NewsApi/GetByIdShow', params: params, });
  },
}

export default newsApi